<template>
  <div class="common-container">
    <div class="wtic">
      <div class="content">
        <div class="c-main" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutWtic",
  data() {
    return {
      content: ''
    }
  },
  created() {
    this.$request.get('/About/wtic')
        .then(res => {
          if (res.code === 0) {
            this.content = res.data.content
          }
        })
  }
}
</script>

<style scoped lang="scss">
.wtic {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ::v-deep {
      .c-main {
        background-color: #FFFFFF;
        padding: 20px;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>